import { InvoiceDetailTypes, SuccessFetch } from "../types/invoiceAdjustmentTypes"
import { useApi } from "utils"
import { adjustmentFreightStore } from "./adjustmentFreightStore"


export function useInvoiceDetail(id:string) {
    const {
        data_invoice,
        setDataInvoice,
        setLoading,
        setTotalDetail,
        setSaldo,
    } = adjustmentFreightStore()

    const api = useApi()
    
    const fetchData = () => {
        setLoading(true)
        const params = {
            invoice_id: id,
        }

        api.get("/invoice/get_freight_adjustment_by_id", { params })
        .then((res) => {
            const response: SuccessFetch<InvoiceDetailTypes[]> = res.data;
            let data = response.payload;
            setDataInvoice(data[0])
            const totalDetail = Number(data[0].freight) + Number(data[0].total_invoice) + Number(data[0].total_tax)
            const totalSaldo = totalDetail -  Number(data[0].tot_payment)
            setTotalDetail(totalDetail)
            setSaldo(totalSaldo)
        })
        .catch(() => {
            setDataInvoice(data_invoice);
        })
        .finally(() => setLoading(false))
    }

    return{
        fetchData,
    }

}